import { HelmetProvider } from "react-helmet-async";

import { ErrorBoundary } from "@/components/ui/error-boundary";
import { readAppEnv } from "@/lib/env";
import type { AnalyticsConfig } from "@/modules/analytics";
import { AnalyticsProvider } from "@/modules/analytics";
import { AuthProvider } from "@/modules/auth";
import { AppRoutes } from "@/routes";

interface AppProps {
  helmetContext?: Record<string, unknown>;
}

function buildAnalyticsConfig(): AnalyticsConfig {
  try {
    const env = readAppEnv();
    return {
      cloudflareToken: env.cloudflareAnalyticsToken,
      enabled: env.enableAnalytics,
      plausibleDomain: env.plausibleDomain,
    };
  } catch {
    return { enabled: false };
  }
}

export default function App({ helmetContext }: AppProps = {}): JSX.Element {
  const analyticsConfig = buildAnalyticsConfig();

  return (
    <ErrorBoundary>
      <HelmetProvider context={helmetContext}>
        <AuthProvider>
          <AnalyticsProvider config={analyticsConfig}>
            <AppRoutes />
          </AnalyticsProvider>
        </AuthProvider>
      </HelmetProvider>
    </ErrorBoundary>
  );
}
